import { ISelectType } from "@4uhub/lib4uhub";
import {
  INewTicketServiceArea,
  ITicketServiceAreaList,
} from "../models/ticket-service-area";
import { TTicketServiceAreaForm } from "../pages/4uChatbot/RegistrationsAndRules/TicketServiceArea/TicketServiceAreaForm/TicketServiceAreaSchema";
import { GlobalAxios } from "./../axios/axios-config";

const TICKET_SERVICE_AREA_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketServiceAreas/";

export class TicketServAreaService {
  create = (item: INewTicketServiceArea) => {
    return GlobalAxios.post(TICKET_SERVICE_AREA_ROUTE, item);
  };

  getItemById = (id: string) => {
    return GlobalAxios.get<TTicketServiceAreaForm>(
      TICKET_SERVICE_AREA_ROUTE + id,
    );
  };

  updateItemById = ({
    item,
    id,
  }: {
    item: INewTicketServiceArea;
    id: string;
  }) => {
    return GlobalAxios.put(TICKET_SERVICE_AREA_ROUTE + id, item);
  };

  activeChildsById = ({ id }: { id: string }) => {
    return GlobalAxios.put(TICKET_SERVICE_AREA_ROUTE + "ActiveChilds/" + id, {
      id,
    });
  };

  inactiveChildsById = ({ id }: { id: string }) => {
    return GlobalAxios.put(TICKET_SERVICE_AREA_ROUTE + "InactiveChilds/" + id, {
      id,
    });
  };

  list = (params?: any) => {
    return GlobalAxios.get<ITicketServiceAreaList[]>(
      TICKET_SERVICE_AREA_ROUTE + "list",
      {
        params: params,
      },
    );
  };
}

export default TicketServAreaService;
